// extracted by mini-css-extract-plugin
export default {"DropZone":"UploadImageDialogue_DropZone__filEi","Thumbnail":"UploadImageDialogue_Thumbnail__TrUgJ"};